<div style="margin: 10px;">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span   [ngClass]="menu_now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <button class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg" (click)="default();act = '1';" style="margin-right: 3%;" >新增假電話</button>
    <select class="form-control" style="width: 250px;display: inline-block;margin-right: 3%;" [(ngModel)]="search_type" (change)="default_page();init_list()">
        <option default disabled value="-2">請選擇帳號類型</option>
        <option *ngFor="let item of account_type_list" [ngValue]="item.id">{{item.name}}</option>
    </select>

    <select class="form-control" style="width: 250px;display: inline-block;margin-right: 3%;" [(ngModel)]="search_enable_type" (change)="default_page();init_list()">
        <option default disabled value="-2">請選擇狀態</option>
        <option *ngFor="let item of enable_list" [ngValue]="item.id">{{item.name}}</option>
    </select>

    <input type="text" class="form-control" style="display: inline-block;width: 280px;" [(ngModel)]="search_phone" (keyup.enter)="default();init_list()" placeholder="請輸入想搜尋的電話號碼後點enter">                          

    <div style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='1'">
        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data">  
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'type'">
                    <div *ngIf="post.val.type == '1'">工程師用</div>
                    <div *ngIf="post.val.type == '2'">陪聊</div>
                    <div *ngIf="post.val.type == '3'">外部免驗證碼使用</div>
                </div>
                <div *ngIf="post.key == 'is_enable'">
                    <div *ngIf="post.val.is_enable == '0'">停用</div>
                    <div *ngIf="post.val.is_enable == '1'">啟用</div>
                </div>
                <div *ngIf="post.key == 'gg'">
                    <a href="javascript:void(0)" title="修改" (click)="default();choose_list(post.val.id)" data-toggle="modal" data-target=".bd-example-modal-lg">
                        <i style="margin-right:10px" class="fas fa-file-signature"></i>
                    </a>
                    <!-- <a href="javascript:void(0)" title="刪除" (click)="default();choose_list(2,post.val.aid)" data-toggle="modal" data-target=".bd-example-modal-lg">
                        <i style="margin-right:10px" class="fas fa-trash"></i>
                    </a> -->
                </div>
            </ng-template>  
        </app-table-v2>
    </div>
    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    <div *ngIf="data.length==0">無資料</div>
</div>
<app-spinner [loading]="loading"></app-spinner>

<div 
*ngIf="edit_data"
class="modal fade bd-example-modal-lg" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static" 
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
 >
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <label class="col-sm-2 col-form-label" *ngIf="act == '1'">新增</label>
                <label class="col-sm-2 col-form-label" *ngIf="act == '2' || act == '0'">修改</label>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label custom">帳號類型</label>
                    <select class="form-control" style="width: 250px;display: inline-block;"
                        [(ngModel)]="edit_data.type"
                    >
                    <option default disabled value="-2">請選擇帳號類型</option>
                    <option *ngFor="let item of account_type_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label custom">國碼</label>
                    <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.country_code">                          
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label custom">電話號碼</label>
                    <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.phone_num">                          
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label custom">六位數字<br>驗證碼</label>
                    <input type="number" class="form-control" style="display: inline-block;width: 220px;margin-right: 2%;" [(ngModel)]="edit_data.password">    
                    <button [ngClass]="'btn-success'" (click)="makecode()" class="btn modalbtn">產生驗證碼</button>                                
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label custom">狀態</label>
                    <button [ngClass]="edit_data.is_enable == 0?'btn-success':'btn-secondary'" (click)="edit_data.is_enable = 0" class="btn modalbtn" style="margin-right: 3%;">停用</button>          
                    <button [ngClass]="edit_data.is_enable == 1?'btn-success':'btn-secondary'" (click)="edit_data.is_enable = 1" class="btn modalbtn">使用</button>                    
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" *ngIf="act == '1' && this.edit_data.type != '-2' &&  this.edit_data.country_code  != '' && this.edit_data.phone_num  != '' && this.edit_data.password  != ''" class="btn btn-primary" data-dismiss="modal" (click)="save('1')">新增</button>
                <button type="button" *ngIf="(act == '0' || act == '2') && this.edit_data.type != '-2' &&  this.edit_data.country_code  != '' && this.edit_data.phone_num  != '' && this.edit_data.password  != ''" class="btn btn-primary" data-dismiss="modal" (click)="save('2')">修改</button>
                <button type="button"  class="btn btn-danger" data-dismiss="modal" (click)="act = '0'">取消</button>
            </div>
        </div>
    </div>
</div>
